// extracted by mini-css-extract-plugin
module.exports = {"component":"item-grid_component__qX1zP","item":"item-grid_item__Hc1je"};